
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/looker",
      function () {
        return require("private-next-pages/sources/looker.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/looker"])
      });
    }
  